import axios from 'axios';
import React, {useState, useEffect, useMemo, Fragment, useRef} from 'react';

import { FormControl, InputLabel, Input, FormHelperText, Alert } from '@mui/material';
import WebService from '@util/webService'
import {encodeParams, getAction, getCodeName, printVariable} from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux';
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
import TableSortLabel from '@mui/material/TableSortLabel';
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField,withStyles,InputBase } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton';
import useSnackbar from '@hooks/useSnackbar';
import MyTableHead from '@components/MyTableHead';
import useIndicator from '@hooks/useIndicator';
import Indicator from '@components/Indicator';
import MyDialog from '@components/MyDialog';
import useForm from '@hooks/useForm';
import Box from '@mui/material/Box';
import ConfirmDialog from "@components/ConfirmDialog";
// pagination
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useLocation } from 'react-router-dom';
import {
  Avatar,
  Grid,
  Container,
} from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import moment from 'moment';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { searchSchool } from '@util/helper';

import RegisterCompanyPage from '@pages/register/register-company.page';
import ProfileCompanySchoolPart from './profile-company.school.part';
import {useParams} from "react-router-dom";
import useAlert from "@hooks/useAlert";
const Boxs = styled(Box)`
      padding-bottom: 40px !important;
    `;


const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`;

const ProfileCompanyTeacherPart = ({dgRef, lectureRef, schoolRef}) => {
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const {alert, renderAlert} = useAlert()
  const [report, set_report] = useState({})
  const g_week_code = "SB07"
  const codes = useSelector(state => state.codeReducer)
  const weekCodes = codes.filter(r => r.codeGroupId === g_week_code)
  const fetchChildren = async() => {
    const url = '/lecture/children'
    const params = {
      lectureId: lectureRef?.current?.id
    }
    openIndicator()
    const resp = await WebService.get(url, params)
    closeIndicator()

    if(resp.repCode != 'ack') {
      alert(resp.repMessage)
      return
    }

    const repMessage = JSON.parse(resp.repMessage)
    return JSON.parse(repMessage.report) 
  }

  const onLoad = async () => {
    const report = await fetchChildren()
    set_report(report)
  }

  useEffect(() => {
    onLoad()
  },[])
  return(
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12} style={{display:'flex', justifyContent:'center'}}>
              <Typography style={{fontWeight:'bold'}}>{lectureRef?.current?.title}</Typography>
              <br/>
            </Grid>
            <Grid item xs={12}>
              <Typography>{schoolRef?.current?.name}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography>{report.smst?.year} / {report.smst?.gisu}</Typography>
            </Grid>
            <Grid item xs={12}> 
              {
                report.lschs?.map(l => (
                  <Typography>{weekCodes.find(r => r.code === l.weekCode)?.name} {l.startTime} ~ {l.endTime}</Typography> 
                ))
              }
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} style={{display:'flex', justifyContent:'center'}}>
          <Button onClick={() => dgRef.current.close()}>닫기</Button>
        </Grid> 
      </Grid>
      <div>
         {renderSnackbar()}
         {renderIndicator()}
         {renderAlert()}

      </div>
    </div>
  )
}

export default ProfileCompanyTeacherPart
